// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiResponseDetail {
    static getAttributeTypeMap() {
        return PharmacyBiResponseDetail.attributeTypeMap;
    }
}
PharmacyBiResponseDetail.discriminator = undefined;
PharmacyBiResponseDetail.additionalProperties = false;
PharmacyBiResponseDetail.attributeTypeMap = [
    {
        "name": "accumulatedDeductibleAmount",
        "baseName": "accumulatedDeductibleAmount",
        "type": "string"
    },
    {
        "name": "additionalNotes",
        "baseName": "additionalNotes",
        "type": "string"
    },
    {
        "name": "annualBenefit",
        "baseName": "annualBenefit",
        "type": "PharmacyBiAnnual"
    },
    {
        "name": "appeal",
        "baseName": "appeal",
        "type": "PharmacyBiAppeal"
    },
    {
        "name": "bin",
        "baseName": "bin",
        "type": "string"
    },
    {
        "name": "cardHolderId",
        "baseName": "cardHolderId",
        "type": "string"
    },
    {
        "name": "coordinationOfBenefits",
        "baseName": "coordinationOfBenefits",
        "type": "string"
    },
    {
        "name": "coPayAppliesToOop",
        "baseName": "coPayAppliesToOop",
        "type": "string"
    },
    {
        "name": "customerId",
        "baseName": "customerId",
        "type": "string"
    },
    {
        "name": "daysSupplyPriced",
        "baseName": "daysSupplyPriced",
        "type": "string"
    },
    {
        "name": "deductible",
        "baseName": "deductible",
        "type": "PharmacyBiDeductible"
    },
    {
        "name": "denial",
        "baseName": "denial",
        "type": "PharmacyBiDenial"
    },
    {
        "name": "drugCoverageStatus",
        "baseName": "drugCoverageStatus",
        "type": "string"
    },
    {
        "name": "estimatedPatientPayAmount",
        "baseName": "estimatedPatientPayAmount",
        "type": "string"
    },
    {
        "name": "family",
        "baseName": "family",
        "type": "PharmacyBiFamily"
    },
    {
        "name": "individual",
        "baseName": "individual",
        "type": "PharmacyBiIndividual"
    },
    {
        "name": "initialCoverageLimit",
        "baseName": "initialCoverageLimit",
        "type": "PharmacyBiInitialCoverageLimit"
    },
    {
        "name": "insurance",
        "baseName": "insurance",
        "type": "PharmacyBiInsurance"
    },
    {
        "name": "isAccumulatorPlan",
        "baseName": "isAccumulatorPlan",
        "type": "string"
    },
    {
        "name": "isMaximizerPlan",
        "baseName": "isMaximizerPlan",
        "type": "string"
    },
    {
        "name": "isOnLowIncomeSubsidy",
        "baseName": "isOnLowIncomeSubsidy",
        "type": "string"
    },
    {
        "name": "lifetimeMaximum",
        "baseName": "lifetimeMaximum",
        "type": "PharmacyBiLifetimeMaximum"
    },
    {
        "name": "lowIncomeSubsidyLevel",
        "baseName": "lowIncomeSubsidyLevel",
        "type": "string"
    },
    {
        "name": "mailOrderPharmacy",
        "baseName": "mailOrderPharmacy",
        "type": "PharmacyBiMailOrderPharmacy"
    },
    {
        "name": "medicarePartD",
        "baseName": "medicarePartD",
        "type": "PharmacyBiMedicarePartD"
    },
    {
        "name": "newPlan",
        "baseName": "newPlan",
        "type": "PharmacyBiNewPlan"
    },
    {
        "name": "obtainPriorAuthorization",
        "baseName": "obtainPriorAuthorization",
        "type": "PharmacyBiObtainPriorAuthorization"
    },
    {
        "name": "obtainTierExceptionPhone",
        "baseName": "obtainTierExceptionPhone",
        "type": "string"
    },
    {
        "name": "otherInsuranceExists",
        "baseName": "otherInsuranceExists",
        "type": "string"
    },
    {
        "name": "payor",
        "baseName": "payor",
        "type": "PharmacyBiPayorResult"
    },
    {
        "name": "pbm",
        "baseName": "pbm",
        "type": "PharmacyBiPbm"
    },
    {
        "name": "pcn",
        "baseName": "pcn",
        "type": "string"
    },
    {
        "name": "peerToPeer",
        "baseName": "peerToPeer",
        "type": "PharmacyBiPeerToPeer"
    },
    {
        "name": "pharmacy",
        "baseName": "pharmacy",
        "type": "PharmacyBiPharmacy"
    },
    {
        "name": "plan",
        "baseName": "plan",
        "type": "PharmacyBiPlan"
    },
    {
        "name": "policy",
        "baseName": "policy",
        "type": "PharmacyBiPolicy"
    },
    {
        "name": "preferredDrugValue",
        "baseName": "preferredDrugValue",
        "type": "string"
    },
    {
        "name": "priorAuthorization",
        "baseName": "priorAuthorization",
        "type": "PharmacyBiPriorAuthorization"
    },
    {
        "name": "productCoverage",
        "baseName": "productCoverage",
        "type": "PharmacyBiProductCoverage"
    },
    {
        "name": "productQuantityLimit",
        "baseName": "productQuantityLimit",
        "type": "string"
    },
    {
        "name": "productTier",
        "baseName": "productTier",
        "type": "string"
    },
    {
        "name": "programId",
        "baseName": "programId",
        "type": "string"
    },
    {
        "name": "quantity",
        "baseName": "quantity",
        "type": "PharmacyBiQuantity"
    },
    {
        "name": "rejectionCode",
        "baseName": "rejectionCode",
        "type": "string"
    },
    {
        "name": "resubmission",
        "baseName": "resubmission",
        "type": "PharmacyBiResubmission"
    },
    {
        "name": "reviewRequired",
        "baseName": "reviewRequired",
        "type": "string"
    },
    {
        "name": "rxGroup",
        "baseName": "rxGroup",
        "type": "PharmacyBiRxGroup"
    },
    {
        "name": "specialtyPharmacy1",
        "baseName": "specialtyPharmacy1",
        "type": "PharmacyBiSpecialtyPharmacyResult"
    },
    {
        "name": "specialtyPharmacy2",
        "baseName": "specialtyPharmacy2",
        "type": "PharmacyBiSpecialtyPharmacyResult"
    },
    {
        "name": "specialtyPharmacy3",
        "baseName": "specialtyPharmacy3",
        "type": "PharmacyBiSpecialtyPharmacyResult"
    },
    {
        "name": "stepTherapy",
        "baseName": "stepTherapy",
        "type": "PharmacyBiStepTherapy"
    },
    {
        "name": "therapyAvailabilityDate",
        "baseName": "therapyAvailabilityDate",
        "type": "string"
    },
    {
        "name": "tierExceptionProcess",
        "baseName": "tierExceptionProcess",
        "type": "string"
    },
    {
        "name": "totalTier",
        "baseName": "totalTier",
        "type": "string"
    },
    {
        "name": "willCoverIfPrimaryDenies",
        "baseName": "willCoverIfPrimaryDenies",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiResponseDetail.js.map